(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const requestType = document.querySelector('[data-contact-request-type]');
    const installationFields = document.querySelector('[data-contact-installation-fields]');
    const form = document.getElementById('ContactForm');
    const phone = document.getElementById('ContactForm-phone');
    const installationConsent = document.querySelector('[data-contact-whatsapp-service]');
    const supportConsent = document.querySelector('[data-contact-whatsapp-reply]');
    const consentError = document.querySelector('[data-contact-consent-error]');
    if (!requestType || !installationFields) return;

    const syncInstallationFields = () => {
      const isInstallationRequest = requestType.value === 'installation';
      installationFields.hidden = !isInstallationRequest;
      installationFields.querySelectorAll('[data-contact-installation-required]').forEach((field) => {
        field.required = isInstallationRequest;
        field.setAttribute('aria-required', String(isInstallationRequest));
      });
      installationConsent.required = isInstallationRequest;
      installationConsent.setAttribute('aria-required', String(isInstallationRequest));
      phone.required = isInstallationRequest;
      phone.setAttribute('aria-required', String(isInstallationRequest));
      document.querySelector('[data-contact-support-whatsapp]').hidden = isInstallationRequest;
      if (isInstallationRequest) supportConsent.checked = false;
    };

    const params = new URLSearchParams(window.location.search);
    if (params.get('request') === 'installation') requestType.value = 'installation';
    document.querySelectorAll('[data-lus-contact-installation]').forEach((link) => {
      link.addEventListener('click', () => {
        requestType.value = 'installation';
        syncInstallationFields();
      });
    });
    requestType.addEventListener('change', syncInstallationFields);
    form.addEventListener('submit', async (event) => {
      if (form.dataset.consentPersisted === 'true') return;
      const isInstallationRequest = requestType.value === 'installation';
      const serviceSelected = isInstallationRequest ? installationConsent.checked : supportConsent.checked;
      if (!serviceSelected) return;
      event.preventDefault();
      consentError.hidden = true;
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = true;
      try {
        const response = await fetch('/apps/water-report/consent', {
          method: 'POST',
          headers: { 'content-type': 'application/json', 'idempotency-key': crypto.randomUUID() },
          body: JSON.stringify({
            phone: phone.value,
            whatsappServiceConsent: true,
            consentContext: isInstallationRequest ? 'installation_request' : 'contact_support',
            formVersion: 'shopify-contact-v1'
          })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || 'Could not save your WhatsApp choice.');
        form.dataset.consentPersisted = 'true';
        form.requestSubmit();
      } catch (error) {
        consentError.textContent = error.message;
        consentError.hidden = false;
        submit.disabled = false;
      }
    });
    syncInstallationFields();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (document.body.classList.contains('template-index') && document.documentElement.dataset.lusCountryMode === 'international') {
        const rootStyle = getComputedStyle(document.documentElement);
        const panelHeight = parseFloat(rootStyle.getPropertyValue('--lus-home-country-height')) || 0;
        const announcementHeight = parseFloat(rootStyle.getPropertyValue('--lus-home-announcement-height')) || 0;
        this.headerBounds = { top: panelHeight + announcementHeight, bottom: panelHeight + announcementHeight + this.header.offsetHeight };
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
